import React from "react";
import xmark from "../../assets/images/xmark.png";
import share from "../../assets/images/Vector (6).png";
import details from "../../assets/images/Overflow (1).png";
import pencil from "../../assets/images/pencil.png";
import flag from "../../assets/images/flag.png";
import dot from "../../assets/images/Ellipse 272.png";
import Tabs from "./Tabs";
import "./overview.css";
import { useNavigate } from "react-router";

export default function Overview() {
  const navigate = useNavigate();
  return (
    <>
    <div className="overview_content" style={{backgroundColor:"var(--gray5)"}}>
        <div className="overview-top">
          <img
            className="xmark"
            onClick={() => navigate(-1)}
            src={xmark}
            alt="xmark"
          />
          <div className="overview-top-right">
          <button className="customer-view">Customer view</button>
          <img src={share} alt="share" />
          <img src={details} alt="details" />
          </div>
        </div>
         <div className="overview-detail-content">
         <div className="overview-detail">
          <p className="headline2" style={{ margin:"8px 0", color:"var(--gray100)"}}>5 days Bali trip</p>
          <img
            src={pencil}
            style={{ width: "12px", height: "13px", marginLeft: "10px" }}
            alt="pencil"
           />
          </div>
        <div className="country-overview">
          <p className="body3" style={{margin:"0", color:"var(--gray80)"}}>London, United Kingdom </p>
          <div className="flag">
            <img src={flag} alt="flag" />
          </div>
        </div>
        <div className="details-overview" style={{fontSize: "15px", margin:"8px 0", color:"#424450"}}>
          <p style={{ margin: "0" }}>Oct 4-7</p>
          <div
            style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}
          >
            <img
              style={{ width: "3px", height: "3px", marginRight: "5px" }}
              src={dot}
              alt="dot"
            />
            <p style={{ margin: "0" }}>4 days</p>
          </div>
          <div
            style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}
          >
            <img
              style={{ width: "3px", height: "3px", marginRight: "5px" }}
              src={dot}
              alt="dot"
            />
            <p style={{ margin: "0" }}> 2 adults, 1 child </p>
          </div>
        </div>
        <div className="category-overview">
          <p style={{fontSize: "15px", margin:"8px 0", color:"#424450"}}>Family trip, </p>
          <p style={{ margin: "8px 5px",fontSize: "15px", color:"#424450"}}>Adventure </p>
        </div>
      </div>
      <Tabs />
    </div>
     <footer className="create-button" style={{height:"56px", padding: "8px 0"}}>
     <button
       className="btn-create"
       variant="contained"
       style={{ width: "90%"}}
       type="submit"
       fullWidth
       disabled
     >
       Save and go next &#8250;
     </button>
   </footer>
    </>
  );
}
